import { useState } from 'react'
import gql from 'graphql-tag'
import { useReadNewsItemMutation } from 'generated/graphql'
import useIntersect from '@app.modules/hooks/useIntersect'

gql`
  mutation ReadNewsItem($newsItemId: ID!) {
    readNewsItem(newsItemId: $newsItemId) {
      newsItem {
        id
      }
    }
  }
`

const useReadNewsItemEffect = (id?: string) => {
  const [isRendered, setIsRendered] = useState(false)
  const [mutate] = useReadNewsItemMutation({
    onCompleted: () => {
      setIsRendered(true)
    },
  })

  const target = useIntersect(() => {
    if (!id || isRendered) return
    mutate({
      variables: {
        newsItemId: id,
      },
    })
  }, [isRendered])

  return target
}

export default useReadNewsItemEffect
